import { render, staticRenderFns } from "./invoiceInvoice.vue?vue&type=template&id=5b0b5633&scoped=true&"
import script from "./invoiceInvoice.vue?vue&type=script&lang=js&"
export * from "./invoiceInvoice.vue?vue&type=script&lang=js&"
import style0 from "./invoiceInvoice.vue?vue&type=style&index=0&id=5b0b5633&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0b5633",
  null
  
)

export default component.exports